import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from 'safe-pipe';
import { environment } from 'src/environments';
import { CloudDriveModalData } from './cloud-drive-modal-data';

const CLOUD_DRIVE_IFRAME_READY = 'SprintRayCloudDriveIframeReady';

const CLOUD_DRIVE_IFRAME_MESSAGE = 'SprintRayCloudDriveIframeMessage';

const CLOSE_CLOUD_DRIVE = 'closeCloudDrive';

@Component({
  selector: 'wl-cloud-drive-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, SafePipe],
  templateUrl: './cloud-drive-modal.component.html',
  styleUrl: './cloud-drive-modal.component.scss',
})
export class CloudDriveModalComponent implements OnInit, OnDestroy {
  @ViewChild('cloudDriveIframe') private _iframeRef!: ElementRef<HTMLIFrameElement>;

  private readonly _dialogConfig = inject<DynamicDialogConfig<CloudDriveModalData>>(DynamicDialogConfig);

  private readonly _ref = inject(DynamicDialogRef);

  private readonly _entity: CloudDriveModalData = this._dialogConfig.data ?? {};

  protected iframeSrc = '';

  private _messageHandler = (event: MessageEvent) => this._onMessage(event);

  ngOnInit() {
    const url = environment?.cloudDriveUrl;
    if (url && this._entity?.email) {
      this.iframeSrc = `${url}&email=${this._entity.email}&redirectable=true`;
    }

    window.addEventListener('message', this._messageHandler);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this._messageHandler);
  }

  private _onMessage(event: MessageEvent) {
    const origin = new URL(this.iframeSrc)?.origin ?? '';
    if (origin && event?.origin === origin) {
      if (event?.data?.type === CLOUD_DRIVE_IFRAME_READY) {
        this.sendDataToIframe(origin);
      } else if (event?.data?.type === CLOUD_DRIVE_IFRAME_MESSAGE) {
        this._ref.close(event.data?.data ?? []);
      } else if (event?.data?.type === CLOSE_CLOUD_DRIVE) {
        this._ref.close();
      }
    }
  }

  private sendDataToIframe(origin: string) {
    const iframe = this._iframeRef?.nativeElement;
    if (iframe && !!Object.keys(this._entity).length) {
      const payload = { type: CLOUD_DRIVE_IFRAME_MESSAGE, data: this._entity };
      iframe.contentWindow?.postMessage(payload, origin);
    }
  }
}
